module.exports = __webpack_public_path__ + "img/scoreActive_05.6c780a0f.svg";